import { z } from "zod"
import { Errors } from "../errors"
import { validatePhoneNumber } from "../shared/filter_dtos"

export const CreateReferralLeadSchema = z.object({
  companyName: z.string().trim().min(1),
  website: z
    .union([z.string().trim().min(1), z.literal("")])
    .transform((value) => (value === "" ? undefined : value))
    .optional(),
  contactName: z.string().trim().min(1),
  role: z.string().trim().min(1),
  email: z.string().trim().email(),
  phone: z
    .string()
    .trim()
    .min(1)
    .refine((value) => validatePhoneNumber(value), {
      message: Errors.INVALID_PHONE_NUMBER,
    }),
})
